import { connect } from "react-redux";
import React, { Component } from "react";
import { Bubble } from "ctia-ui";
import FormElement from "components/FormElement";
import { handleInputChange, setValue } from "actions/request";
import {
  fetchModelEPR,
  mapSelectedModelFields
} from "actions/battery/eprRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";
import { hasStringValue } from "helpers/RequestHelper";
import * as formHelper from "helpers/FormHelper";
import * as modelHelper from "helpers/ModelHelper";

class RequestEcoModelEPR extends Component {
  state = { touched: false, fieldName: "existedModel" };

  componentDidMount() {
    this.setState({
      fieldName: formHelper.defineModelFieldId(this.props.request)
    });
  }

  isValidationRequired = () => {
    return this.props.user.canEditModelname;
  };

  validateModelName() {
    if (!this.isValidationRequired() || !this.state.touched) return null;

    return hasStringValue(this.props.request, this.state.fieldName)
      ? null
      : "error";
  }

  onFieldChanged = event => {
    if (!this.state.touched) {
      this.setState({ touched: true });
    }

    const model = modelHelper.findExistedModelByName(
      event.target.value,
      this.props.requests.eprEcoModels
    );

    if (model) {
      this.props.setValue("modelName", event.target.value);
      this.props
        .fetchModelEPR(model.value, this.props.request.ieee)
        .then(() =>
          this.props.mapSelectedModelFields(model.devicemodelbatterycomponent)
        )
        .then(() => this.props.handleInputChange(event));
    } else {
      console.error("Model for EPRR request can't be found.");
    }
  };

  render() {
    const { requests, request } = this.props;
    const isEditable = this.isValidationRequired();
    const inputType = formHelper.defineEcoModelFieldType(isEditable, request);
    const modelName = formHelper.defineEcoModelName(isEditable, request);
    const { eprEcoModels } = requests || [];

    if (eprEcoModels && eprEcoModels.length === 0) {
      return (
        <Bubble type="danger">
          Please submit an EPRR Initial request first in order to submit the
          ECO.
        </Bubble>
      );
    }

    return (
      <FormElement
        id={this.state.fieldName}
        type={inputType}
        label="Model Name/Number"
        value={modelName}
        options={eprEcoModels}
        editable={isEditable}
        onChange={this.onFieldChanged}
        validationState={this.validateModelName()}
        validationMessage={formHelper.emptyMsg}
        customOptions={{
          combobox: false,
          notFoundContent: "Model Name not found"
        }}
        useIdAsValue={true}
      />
    );
  }
}

function mapStateToProps({ requests, request, user }) {
  return { requests, request, user };
}

export default connect(mapStateToProps, {
  handleInputChange,
  fetchModelEPR,
  mapSelectedModelFields,
  mapNonSarManufSites,
  setValue
})(RequestEcoModelEPR);
